module.exports = __webpack_public_path__ + "media/images/officebooking-bg-b3cd154c.jpg";